import { AnimationWrapper } from '@natu/ui/Decorators/AnimationWrapper';

import { type BlokItem, DynamicRender, sbEditable, type SBProps } from '../../../../utils';

interface SBAnimationWrapperProps {
  body?: BlokItem[];
  distance?: number;
  direction?: 'top-to-bottom' | 'bottom-to-top' | 'left-to-right' | 'right-to-left';
  fade?: boolean;
}

export const SBAnimationWrapper = ({ blok }: SBProps<SBAnimationWrapperProps>) => {
  const { body, ...animationWrapperProps } = blok;

  return (
    <AnimationWrapper {...animationWrapperProps} {...sbEditable(blok)}>
      <DynamicRender data={body} />
    </AnimationWrapper>
  );
};
